module.exports = __webpack_public_path__ + "img/bear.65a38514.png";